import React, { useMemo } from "react";
import { AlertTriangle } from "lucide-react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const EXCEPTION_STYLE = {
  MISSING_BANK:       { label: "Missing bank details",   color: "text-red-400",    bg: "bg-red-500/10 border-red-500/20"       },
  NEGATIVE_NET_RISK:  { label: "Net pay negative risk",  color: "text-orange-400", bg: "bg-orange-500/10 border-orange-500/20" },
  MISSING_PAN:        { label: "Missing PAN",            color: "text-yellow-400", bg: "bg-yellow-500/10 border-yellow-500/20" },
  LOP_UNRESOLVED:     { label: "LOP unresolved",         color: "text-fuchsia-400",bg: "bg-fuchsia-500/10 border-fuchsia-500/20"},
  BANK_VERIFY_PENDING:{ label: "Bank verify pending",    color: "text-blue-400",   bg: "bg-blue-500/10 border-blue-500/20"     },
};

export default function ExceptionsPanel({ rows, onFix }) {
  const items = useMemo(() => {
    const out = [];
    (rows || []).forEach(r => (r.exceptions || []).forEach(code => out.push({ emp: r, code })));
    return out;
  }, [rows]);

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <div className="flex items-center gap-2">
          {items.length > 0 && <AlertTriangle size={13} className="text-yellow-400" />}
          <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Exceptions</span>
        </div>
        <span className={`text-xs px-2 py-0.5 rounded-full border ${items.length > 0 ? "text-yellow-400 bg-yellow-500/10 border-yellow-500/20" : "text-white/30 bg-white/5 border-white/10"}`}>
          {items.length}
        </span>
      </div>

      <div className="p-4 space-y-2 max-h-72 overflow-y-auto">
        {items.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No exceptions — run is clean.</p>
        ) : (
          items.map((x, i) => {
            const cfg = EXCEPTION_STYLE[x.code] || { label: x.code, color: "text-white/40", bg: "bg-white/5 border-white/10" };
            return (
              <div key={i} className="flex items-center justify-between gap-3 rounded-lg border border-white/5 bg-white/3 px-4 py-3">
                <div className="min-w-0">
                  <p className="text-sm text-white/70 font-medium">{x.emp.name}
                    <span className="text-white/30 text-xs ml-2">{x.emp.empCode}</span>
                  </p>
                  <span className={`text-xs px-2 py-0.5 rounded-full border mt-1 inline-block ${cfg.bg} ${cfg.color}`}>
                    {cfg.label}
                  </span>
                </div>
                <button onClick={() => onFix?.(x.emp.id, x.code)}
                  className="text-xs px-2.5 py-1.5 rounded-lg border border-[#00ff90]/20 bg-[#00ff90]/5 text-[#00ff90]/60 hover:bg-[#00ff90]/15 hover:text-[#00ff90] transition-colors shrink-0">
                  Mark Fixed
                </button>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}